// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1-Nsm","list":"BalanceDue_list__3N77k","listRow":"BalanceDue_listRow__3icT-","total":"BalanceDue_total__10x2C"};